import { render, staticRenderFns } from "./VipSection.vue?vue&type=template&id=256cae90&"
import script from "./VipSection.vue?vue&type=script&lang=js&"
export * from "./VipSection.vue?vue&type=script&lang=js&"
import style0 from "./VipSection.vue?vue&type=style&index=0&id=256cae90&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports